import { FlexCenterCol } from ".";
import { INoSelectableBox } from "@/interfaces";
import { cn } from "@/lib";
import { cva } from "class-variance-authority";
import Link from "next/link";

export type TVariantType =
  | "emerald-mint"
  | "sky-bliss"
  | "teal-ocean"
  | "sunset-gold"
  | "yellow-500"
  | "rose-500";

const boxStyles = cva(
  "lg:size-36 sm:size-25 size-20 bg-white sm:p-2 p-1 rounded-xl border-[1.5px] border-transparent overflow-hidden cursor-pointer shadow-main transition",
  {
    variants: {
      variant: {
        "emerald-mint":
          "hover:shadow-emerald-mint! border-emerald-mint! hover:text-emerald-mint!",
        "sky-bliss":
          "hover:shadow-sky-bliss! border-sky-bliss! hover:text-sky-bliss!",
        "teal-ocean":
          "hover:shadow-teal-ocean! border-teal-ocean! hover:text-teal-ocean!",
        "sunset-gold":
          "hover:shadow-sunset-gold! border-sunset-gold! hover:text-sunset-gold!",
        "yellow-500":
          "hover:shadow-yellow-500! border-yellow-500! hover:text-yellow-500!",
        "rose-500":
          "hover:shadow-rose-500! border-rose-500! hover:text-rose-500!",
        disabled: "border-gray-400! ",
      },
    },
  },
);

const iconStyles = cva("lg:size-14 sm:size-10 size-6 transition", {
  variants: {
    variant: {
      "emerald-mint": "text-emerald-mint",
      "sky-bliss": "text-sky-bliss",
      "teal-ocean": "text-teal-ocean",
      "sunset-gold": "text-sunset-gold",
      "yellow-500": "text-yellow-500",
      "rose-500": "text-rose-500",
      disabled: "text-gray-400! ",
    },
  },
});

const NoSelectableBox = ({
  icon,
  label,
  href,
  onClick,
  variant,
  disabled,
}: INoSelectableBox & {
  onClick?: () => void;
  variant: TVariantType;
}) => {
  return (
    <Link
      title={label}
      href={!disabled ? href : "#"}
      className={cn(disabled && "pointer-events-none text-gray-400!")}
    >
      <FlexCenterCol gap={4}>
        <FlexCenterCol
          onClick={onClick ?? undefined}
          className={cn(
            boxStyles({ variant: disabled ? "disabled" : variant }),
            "gap-2 lg:gap-4",
          )}
        >
          <div
            className={iconStyles({ variant: disabled ? "disabled" : variant })}
          >
            {icon}
          </div>
          <p
            className={
              "text-micro text-center transition-colors sm:text-xs lg:text-sm!"
            }
          >
            <span>{label}</span>
          </p>
        </FlexCenterCol>
      </FlexCenterCol>
    </Link>
  );
};

export default NoSelectableBox;
